<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "App"
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Fira+Sans&display=swap");
#app {
  font-family: "Fira Sans", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
* {
  margin: 0;
  padding: 0;
   /*filter: invert(1000%);*/
}
.btn {
  border: none;
  border-radius: 0 !important;
  padding: 0.2rem 1rem !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue